import { render, staticRenderFns } from "./sportsBetting.vue?vue&type=template&id=36a59ded"
import script from "./sportsBetting.vue?vue&type=script&lang=js"
export * from "./sportsBetting.vue?vue&type=script&lang=js"
import style0 from "./sportsBetting.vue?vue&type=style&index=0&id=36a59ded&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports